export default __webpack_public_path__ + "static/Raw_Prime_Meat-2beab2427f89ebec187d3baea886607e.png";